import { formatNumeric } from './numeric';

/**
 * Format ACN.
 *
 * @param value - ACN string.
 * @returns Formatted ACN string.
 */
export function formatACN(value?: string) {
  return formatNumeric(value, '### ### ###');
}
